export default () => {
    const extensions = map => ({
        getDefaultNodeText(node) {
            return `Node ${node.id}`
        },

        getNodeText(node) {
            return node.data.text ?? this.getDefaultNodeText(node)
        },

        getNodeTitle(node) {
            return null
        },
    })

    return {extensions}
}
